import React from "react";
import PropTypes from "prop-types";
import Linkify from "../../atoms/Linkify";
import VarsomeVariantLink from "./VarsomeVariantLink";
import PubmedLink from "./PubmedLink";

const conf = [
  {
    regexMatch: new RegExp(/%%PUBMED:\s*(\d+)%%/, "gi"),
    Renderer: PubmedLink,
  },
  {
    regexMatch: new RegExp(/##chr.*##/, "gi"),
    Renderer: VarsomeVariantLink,
  },
];

function LinkifyBase({ txt }) {
  return txt ? <Linkify text={txt} isHtmlDirty={false} conf={conf} /> : txt;
}

LinkifyBase.propTypes = {
  txt: PropTypes.string,
};

LinkifyBase.defaultProps = {
  txt: "",
};

export default React.memo(LinkifyBase);
